import { __extends } from "tslib";
import { IgrFormatSpecifier } from "./igr-format-specifier";
import { NumberFormatSpecifier as NumberFormatSpecifier_internal } from "./NumberFormatSpecifier";
import { ensureBool } from "./componentUtil";
var IgrNumberFormatSpecifier = /** @class */ /*@__PURE__*/function (_super) {
  __extends(IgrNumberFormatSpecifier, _super);
  function IgrNumberFormatSpecifier() {
    return _super.call(this) || this;
  }
  IgrNumberFormatSpecifier.prototype.createImplementation = function () {
    return new NumberFormatSpecifier_internal();
  };
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "i", {
    /**
                                 * @hidden
                                 */
    get: function get() {
      return this._implementation;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "locale", {
    get: function get() {
      return this.i.locale;
    },
    set: function set(v) {
      this.i.locale = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "compactDisplay", {
    get: function get() {
      return this.i.compactDisplay;
    },
    set: function set(v) {
      this.i.compactDisplay = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "currency", {
    get: function get() {
      return this.i.currency;
    },
    set: function set(v) {
      this.i.currency = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "currencyDisplay", {
    get: function get() {
      return this.i.currencyDisplay;
    },
    set: function set(v) {
      this.i.currencyDisplay = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "currencySign", {
    get: function get() {
      return this.i.currencySign;
    },
    set: function set(v) {
      this.i.currencySign = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "currencyCode", {
    get: function get() {
      return this.i.currencyCode;
    },
    set: function set(v) {
      this.i.currencyCode = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "localeMatcher", {
    get: function get() {
      return this.i.localeMatcher;
    },
    set: function set(v) {
      this.i.localeMatcher = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "notation", {
    get: function get() {
      return this.i.notation;
    },
    set: function set(v) {
      this.i.notation = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "numberingSystem", {
    get: function get() {
      return this.i.numberingSystem;
    },
    set: function set(v) {
      this.i.numberingSystem = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "signDisplay", {
    get: function get() {
      return this.i.signDisplay;
    },
    set: function set(v) {
      this.i.signDisplay = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "style", {
    get: function get() {
      return this.i.style;
    },
    set: function set(v) {
      this.i.style = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "unit", {
    get: function get() {
      return this.i.unit;
    },
    set: function set(v) {
      this.i.unit = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "unitDisplay", {
    get: function get() {
      return this.i.unitDisplay;
    },
    set: function set(v) {
      this.i.unitDisplay = v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "useGrouping", {
    get: function get() {
      return this.i.useGrouping;
    },
    set: function set(v) {
      this.i.useGrouping = ensureBool(v);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "minimumIntegerDigits", {
    get: function get() {
      return this.i.minimumIntegerDigits;
    },
    set: function set(v) {
      this.i.minimumIntegerDigits = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "minimumFractionDigits", {
    get: function get() {
      return this.i.minimumFractionDigits;
    },
    set: function set(v) {
      this.i.minimumFractionDigits = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "maximumFractionDigits", {
    get: function get() {
      return this.i.maximumFractionDigits;
    },
    set: function set(v) {
      this.i.maximumFractionDigits = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "minimumSignificantDigits", {
    get: function get() {
      return this.i.minimumSignificantDigits;
    },
    set: function set(v) {
      this.i.minimumSignificantDigits = +v;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(IgrNumberFormatSpecifier.prototype, "maximumSignificantDigits", {
    get: function get() {
      return this.i.maximumSignificantDigits;
    },
    set: function set(v) {
      this.i.maximumSignificantDigits = +v;
    },
    enumerable: false,
    configurable: true
  });
  return IgrNumberFormatSpecifier;
}(IgrFormatSpecifier);
export { IgrNumberFormatSpecifier };